import { LoaderCircle } from "lucide-react";
import { usePrivy } from "@privy-io/react-auth";
import type { PropsWithChildren } from "react";

const RestrictedRoute = ({ children }: PropsWithChildren) => {
  const { ready } = usePrivy();

  return !ready ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <LoaderCircle className="h-12 w-12 animate-spin stroke-accent m-auto" />
    </div>
  ) : (
    children
  );
};

export default RestrictedRoute;
